import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {

  /**
   * Creates an instance of disclaimer component.
   * @param commonService 
   */
  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
  }


  /**
   * Accepts disclaimer
   */
  acceptDisclaimer(){
    localStorage.setItem("disclaimerAgree", "true")
    this.commonService.navigateToPage('/home')
  }
}
